<template>
  <div v-if="release" class="changelog-release group">
    <div class="-mx-8 px-8 py-6 xl:flex">
      <div class="version lg:w-full xl:max-w-xs">
        <div class="relative">
          <a
            :href="'#v' + release.version"
            class="absolute top-0 -left-0 transform -translate-x-full text-link hidden group-hover:inline-block px-2 py-2 leading-none"
            :title="'Version ' + release.version"
          >
            <c-icon icon="link" />
          </a>

          <h2 :id="'v' + release.version" class="mt-6 mb-2">
            Version {{ release.version }}
          </h2>

          <div class="date text-gray-500">
            {{ $luxon(release.date) }}
          </div>
          <div
            v-if="release.critical"
            class="critical uppercase text-red-500 border border-red-500 border-solid inline-block px-1 py-0 rounded text-sm mt-2"
          >
            Critical
          </div>
        </div>
      </div>

      <prose-block class="flex-1">
        <!-- eslint-disable vue/no-v-html -->
        <div class="details readable pt-6 lg:flex-1" v-html="release.notes" />
        <!-- eslint-enable vue/no-v-html -->
      </prose-block>
    </div>
  </div>
</template>

<script>
  import ProseBlock from './ProseBlock';
  export default {
    components: {ProseBlock},
    props: {
      release: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<style lang="postcss">
  .changelog-release {
    .prose > div > :first-child {
      @apply mt-0;
    }
  }
</style>
